import { AxiosPromise } from 'axios';
import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';
import { ConsumerLoanBrief } from '../models/ConsumerLoanBrief';

export const getCoApplicantApplications = (personId: number | string): AxiosPromise<ConsumerLoanBrief[]> => {
    return AxiosClientFactory
        .getInstance()
        .get<ConsumerLoanBrief[]>(`/api/coapplicants/${personId}/applications`);
};
